import React from 'react';

const WeatherDisplay = ({ weatherData }) => {
    return (
        <div>
            <h2>Weather Information</h2>
            <p>Temperature: {weatherData.main && weatherData.main.temp}°K</p>
            <p>Description: {weatherData.weather && weatherData.weather[0].description}</p>
            <img src={weatherData.weather && `http://openweathermap.org/img/w/${weatherData.weather[0].icon}.png`} alt="Weather Icon" />
            <p>Longitude: {weatherData.coord && weatherData.coord.lon}</p>
            <p>Latitude: {weatherData.coord && weatherData.coord.lat}</p>
        </div>
    );
};

export default WeatherDisplay;
